const PL = {
	Caucasian: 'Kaukaska',
	Arab: 'Arabska',
	Mixed: 'Mieszana',
	'Native American': 'Rdzenna Amerykanka',
	'Pacific Islander': 'Pacyfik',
	'South Asian': 'Południowa Azja',
	African: 'Afrykańska',
	Hispanic: 'Latynoska',
	'Middle Eastern': 'Bliski Wschód',
	Asian: 'Azjatycka',
	'Crew cut': 'Krótkie na jeża',
	'Buzz cut': 'Bardzo krótkie',
	'Curly hair': 'Kręcone włosy',
	'Bald hair': 'Łysy',
	'Man bun': 'Koczek',
	'Clean-shaven head': 'Ogolona głowa',
	'French twist': 'Upięcie po francusku',
	'Styled braids': 'Splecione warkocze',
	'Space buns': 'Podwójne kokice',
	'Pixie cut': 'Krótkie pixie',
	'Layered hair': 'Warstwowe włosy',
	Ponytail: 'Kucyk',
	'Short bob': 'Krótki bob',
	'Elegant bun': 'Elegancki kok',
	'Voluminous curls': 'Objęte loki',
	'Wavy hair': 'Falowane włosy',
	'Long hair': 'Długie włosy',
	'Long straight hair': 'Długie proste włosy',
	'Long layers': 'Długie warstwy',
	Wavy: 'Falowane',
	Long: 'Długie',
	'Pink purple blue': 'Różowo-fioletowo-niebieskie',
	'Honey blonde ombre': 'Miodowy blond ombre',
	Balleyage: 'Cieniowanie balayage',
	'Platinum blonde hair': 'Platynowy blond',
	'Strawberry blonde hair': 'Truskawkowy blond',
	'Red hair': 'Rude włosy',
	'Lightbrown hair': 'Jasny brąz',
	'Brown hair': 'Brązowe włosy',
	'Black hair': 'Czarne włosy',
	'Blonde hair': 'Blond',
	Brunette: 'Brunetka',
	'Dirty blonde hair': 'Brudny blond',
	'Light brown hair': 'Jasny brąz',
	'Salt-and-pepper hair': 'Siwe włosy',
	'Fantasy purple hair': 'Fioletowe włosy',
	'Dark brown hair': 'Ciemny brąz',
	Chubby: 'Pulchna',
	Curvy: 'Krągła',
	Average: 'Przeciętna',
	Athletic: 'Sportowa',
	Skinny: 'Szczupła',
	Muscular: 'Umięśniona',
	Grey: 'Szare',
	Hazel: 'Piwne',
	Green: 'Zielone',
	Blue: 'Niebieskie',
	Brown: 'Brązowe',
	Small: 'Mały',
	Medium: 'Średni',
	Large: 'Duży',
	'Extra large': 'Bardzo duży',
	None: 'Brak',
	Normal: 'Normalny',
	Big: 'Duży',
};

const DE = {
	Caucasian: 'Kaukasisch',
	Arab: 'Arabisch',
	Mixed: 'Gemischt',
	'Native American': 'Indigene Amerikanerin',
	'Pacific Islander': 'Pazifikinsel',
	'South Asian': 'Südasiatisch',
	African: 'Afrikanisch',
	Hispanic: 'Hispanisch',
	'Middle Eastern': 'Nahost',
	Asian: 'Asiatisch',
	'Crew cut': 'Bürstenschnitt',
	'Buzz cut': 'Röschen',
	'Curly hair': 'Lockige Haare',
	'Bald hair': 'Glatze',
	'Man bun': 'Dutt',
	'Clean-shaven head': 'Rasierter Kopf',
	'French twist': 'Französische Flechtfrisur',
	'Styled braids': 'Geflochtene Frisur',
	'Space buns': 'Doppel-Dutt',
	'Pixie cut': 'Pixie-Schnitt',
	'Layered hair': 'Stufige Haare',
	Ponytail: 'Pferdeschwanz',
	'Short bob': 'Kurzer Bob',
	'Elegant bun': 'Eleganter Dutt',
	'Voluminous curls': 'Voluminöse Locken',
	'Wavy hair': 'Wellige Haare',
	'Long hair': 'Lange Haare',
	'Long straight hair': 'Lange glatte Haare',
	'Long layers': 'Lange Stufen',
	Wavy: 'Wellig',
	Long: 'Lang',
	'Pink purple blue': 'Pink-Lila-Blau',
	'Honey blonde ombre': 'Honigblond Ombre',
	Balleyage: 'Balayage',
	'Platinum blonde hair': 'Platinblond',
	'Strawberry blonde hair': 'Erdbeerblond',
	'Red hair': 'Rote Haare',
	'Lightbrown hair': 'Hellbraun',
	'Brown hair': 'Braune Haare',
	'Black hair': 'Schwarze Haare',
	'Blonde hair': 'Blond',
	Brunette: 'Brünett',
	'Dirty blonde hair': 'Schmutzblond',
	'Light brown hair': 'Hellbraun',
	'Salt-and-pepper hair': 'Salz und Pfeffer',
	'Fantasy purple hair': 'Fantasy Lila',
	'Dark brown hair': 'Dunkelbraun',
	Chubby: 'Mollig',
	Curvy: 'Kurvig',
	Average: 'Durchschnittlich',
	Athletic: 'Athletisch',
	Skinny: 'Schlank',
	Muscular: 'Muskulös',
	Grey: 'Grau',
	Hazel: 'Haselnuss',
	Green: 'Grün',
	Blue: 'Blau',
	Brown: 'Braun',
	Small: 'Klein',
	Medium: 'Mittel',
	Large: 'Groß',
	'Extra large': 'Extra groß',
	None: 'Keine',
	Normal: 'Normal',
	Big: 'Groß',
};

const CS = {
	Caucasian: 'Kaukaská',
	Arab: 'Arabská',
	Mixed: 'Smíšená',
	'Native American': 'Domorodá Američanka',
	'Pacific Islander': 'Tichomořský ostrovan',
	'South Asian': 'Jižní Asie',
	African: 'Africká',
	Hispanic: 'Hispánská',
	'Middle Eastern': 'Blízký východ',
	Asian: 'Asijská',
	'Crew cut': 'Na ježka',
	'Buzz cut': 'Velmi krátké',
	'Curly hair': 'Kudrnaté vlasy',
	'Bald hair': 'Holohlavá',
	'Man bun': 'Cop',
	'Clean-shaven head': 'Oholená hlava',
	'French twist': 'Francouzský drdol',
	'Styled braids': 'Copánky',
	'Space buns': 'Dva drdoly',
	'Pixie cut': 'Pixie střih',
	'Layered hair': 'Vrstvené vlasy',
	Ponytail: 'Cop',
	'Short bob': 'Krátký bob',
	'Elegant bun': 'Elegantní drdol',
	'Voluminous curls': 'Objemné kudrliny',
	'Wavy hair': 'Vlnité vlasy',
	'Long hair': 'Dlouhé vlasy',
	'Long straight hair': 'Dlouhé rovné vlasy',
	'Long layers': 'Dlouhé vrstvy',
	Wavy: 'Vlnité',
	Long: 'Dlouhé',
	'Pink purple blue': 'Růžovo-fialovo-modré',
	'Honey blonde ombre': 'Medový blond ombre',
	Balleyage: 'Melírování balayage',
	'Platinum blonde hair': 'Platinový blond',
	'Strawberry blonde hair': 'Jahodový blond',
	'Red hair': 'Zrzavé vlasy',
	'Lightbrown hair': 'Světle hnědé',
	'Brown hair': 'Hnědé vlasy',
	'Black hair': 'Černé vlasy',
	'Blonde hair': 'Blond',
	Brunette: 'Bruneta',
	'Dirty blonde hair': 'Špinavý blond',
	'Light brown hair': 'Světle hnědé',
	'Salt-and-pepper hair': 'Šedivé vlasy',
	'Fantasy purple hair': 'Fialové vlasy',
	'Dark brown hair': 'Tmavě hnědé',
	Chubby: 'Baculatá',
	Curvy: 'Křivky',
	Average: 'Průměrná',
	Athletic: 'Atletická',
	Skinny: 'Hubená',
	Muscular: 'Svalnatá',
	Grey: 'Šedé',
	Hazel: 'Lísková',
	Green: 'Zelené',
	Blue: 'Modré',
	Brown: 'Hnědé',
	Small: 'Malé',
	Medium: 'Střední',
	Large: 'Velké',
	'Extra large': 'Extra velké',
	None: 'Žádné',
	Normal: 'Normální',
	Big: 'Velké',
};

export const STUDIO_GRID_OPTION_LABELS = {
	en: {},
	pl: PL,
	de: DE,
	cs: CS,
};

export const getStudioGridOptionLabel = (lang, label) => {
	if (!label) {
		return '';
	}

	return STUDIO_GRID_OPTION_LABELS[lang]?.[label] ?? label;
};
